import axios from 'axios';
import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, configRefs } from '@utils/constants';

const cache = createCacheWrapper({
  capacity: 100,
  timeToLiveMs: 1 * DAYS_TO_MS
});
async function getStudentsInClass(user, className) {
  return cache(className, async () => {
    var _a;
    if (!user || user.authenticationProvider === "ekey" || !user.institution) {
      return [];
    }
    const response = await axios.post(
      `${(_a = await configRefs.apis.gas.get()) == null ? void 0 : _a.replaceAll(
        "{{version}}",
        "v2"
      )}/api/v2/Unic/Institution/GetClassStudents`,
      {
        InstitutionNumber: user.institution.id,
        ClassName: className
      }
    );
    return response.data.map((item) => ({
      id: item.UserId,
      name: item.FirstName || item.LastName ? `${item.FirstName} ${item.LastName}` : item.Name,
      email: item.Email
    })).sort(
      (a, b) => a.name.localeCompare(b.name, "da-DK", { numeric: true })
    );
  }).getStaleWhileRevalidate();
}

export { getStudentsInClass };
//# sourceMappingURL=request.get-students-in-class.js.map
